/** Returns the address only when it is an http(s) URL; otherwise undefined (omit the href). */
export function safeHttpHref(address: unknown): string | undefined {
    if (typeof address !== 'string') return undefined
    return /^\s*https?:\/\/[^\s/?#]/i.test(address) ? address : undefined
}
